module.exports = __webpack_public_path__ + "img/webeditor-technical-1.4d6a454e.png";